import { get } from './data-manager'
import * as markerClusterer from "@googlemaps/markerclusterer";

export default class MapPoints {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.blockId = $wrapper.dataset.blockId;
        this.$mapEl = $wrapper.querySelector('[data-map]');
        this.markerClustersEnabled = this.$mapEl.dataset.markerClustersEnabled;
        this.markerImage = this.$mapEl.dataset.marker;
        this.mapStyle = this.$mapEl.dataset.mapStyle;
        this.map = null;
        this.markers = [];
        this.points = [];
        this.mapInitialized = false;

        this.initMap = this.initMap.bind(this);

        this.getPoints();
    }

    getZoom() {
        const isMobile = window.matchMedia("(max-width: 599px)").matches;
        const isTablet = window.matchMedia("(min-width: 600px) and (max-width: 1023px)").matches;
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

        switch (true) {
            case isMobile:
                return 7.5;
                break;
            case isTablet:
                return 8.5;
                break;
            case isDesktop:
                return 8.5;
                break;
        }
    }
    getCenter() {
        const isMobile = window.matchMedia("(max-width: 599px)").matches;
        const isTablet = window.matchMedia("(min-width: 600px) and (max-width: 1023px)").matches;
        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

        switch (true) {
            case isMobile:
                return { lat: 51.2095165, lng: 4.3896324 };
                break;
            case isTablet:
                return { lat: 51.0095165, lng: 3.9896324 };
                break;
            case isDesktop:
                return{ lat: 51.0095165, lng: 3.9896324 };
                break;
        }
    }

    /**
     * Initialize google map
     * @return {Promise<void>}
     */
    async initMap() {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        let zoom = this.getZoom();
        let center = this.getCenter();

        this.map = new google.maps.Map(this.$mapEl, {
            zoom: zoom,
            center: center,
            disableDefaultUI: true,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{ "color": "#081D3E" }]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        { "color": "#293E5F" }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        { "color": "#314667" },
                        { "weight": 0.5 }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{ "visibility": "off" }]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        { "color": "#54698A" },
                        { "weight": 1 }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "labels",
                    "stylers": [
                        { "visibility": "off" }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        { "visibility": "off" }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels",
                    "stylers": [
                        { "visibility": "on" }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        { "color": "#8A9FC0" }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        { "color": "#566B8C" },
                        { "weight": 1 }
                    ]
                }
            ]
        });

        this.points.forEach((point) => {
            if (!point.latitude || !point.longitude) {
                return;
            }

            const marker = new google.maps.Marker({
                map: this.map,
                position: {
                    lat: parseFloat(point.latitude),
                    lng: parseFloat(point.longitude),
                },
                title: point.title,
                icon: {
                    url: this.getMarkerSource(),
                    scaledSize: new google.maps.Size(50, 50),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(25, 50)
                }
            });

            marker.eventEpisode = point;
            this.markers.push(marker);
        });

        this.mapInitialized = true;
    }

    /**
     * Get the event locations
     */
    async getPoints() {
        const url = `${currentHref}/block/${this.blockId}/ajax/`;

        if (this.abortController) {
            this.abortController.abort();
        }

        this.abortController = new AbortController();
        const result = await get(url, [], this.abortController.signal);
        if( ! result) {
            return;
        }
        this.points = result.publications;

        this.initMap();
    }

    getMarkerSource()
    {
        const url = new URL(baseHref);
        return url.origin + '/src/skins/default/image/map-marker.svg';
    }
}

class mapMarkerClusterRenderer {
    render({ count, position }, stats, map) {
        return new google.maps.Marker({
            position,
            label: {
                text: String(count),
                fontWeight: '900',
                color: '#FFFFFF',
                className: 'event-episode-list__marker-label',
            },
            icon: {
                url: "/themes/njam-2/img/marker.svg",
                anchor: new google.maps.Point(30, 60),
            }
        });
    }


}
